import { apiFetch } from '@/lib/api'
import type { OverrideRow, OverrideStatus } from '@/lib/kantar-dia'
import type { ReconcileService } from '@/services/contracts'

/** Backend `OverrideRead`. */
interface OverrideReadDto {
  kantar_adi: string
  tartino: number
  status: OverrideStatus | null
  note: string
  updated_by_name: string | null
  updated_at: string
}

function toOverride(dto: OverrideReadDto): OverrideRow {
  return {
    kantarAdi: dto.kantar_adi,
    tartino: dto.tartino,
    status: dto.status,
    note: dto.note,
    updatedByName: dto.updated_by_name,
    updatedAt: dto.updated_at,
  }
}

const path = (kantarAdi: string, tartino: number) =>
  `/reconcile/overrides/${encodeURIComponent(kantarAdi)}/${tartino}`

export const httpReconcileService: ReconcileService = {
  async listOverrides() {
    return (await apiFetch<OverrideReadDto[]>('/reconcile/overrides')).map(toOverride)
  },

  async setOverride(kantarAdi, tartino, input) {
    return toOverride(
      await apiFetch<OverrideReadDto>(path(kantarAdi, tartino), { method: 'PUT', body: input }),
    )
  },

  async deleteOverride(kantarAdi, tartino) {
    await apiFetch<void>(path(kantarAdi, tartino), { method: 'DELETE' })
  },
}
